export const chunk = <T>(arr: T[], chunkSize = 1, cache: T[][] = []) => {
  const tmp = [...arr];
  if (chunkSize <= 0) return cache;
  while (tmp.length) cache.push(tmp.splice(0, chunkSize));
  return cache;
};

export const intersection = (arr, ...args) =>
  arr.filter((item) => args.every((arr) => arr.includes(item)));

export const isString = (str) => typeof str === 'string';
